import { parseEther } from "ethers/lib/utils";
import ENV from "./env";

const NUM_CONFIRMATIONS = 8;

const ADDRESSES = {
  // // hardhat chain
  // 31337: {
  //   ADDRESS_SUPERFLUID_RESOLVER: ENV.LOCAL_ADDRESS_SUPERFLUID_RESOLVER,
  //   ADDRESS_SUPERFLUID_HOST: ENV.LOCAL_ADDRESS_SUPERFLUID_HOST,
  //   ADDRESS_SUPERFLUID_CFA: ENV.LOCAL_ADDRESS_SUPERFLUID_CFA,
  //   ADDRESS_SUPERFLUID_IDA: ENV.LOCAL_ADDRESS_SUPERFLUID_IDA,

  //   ADDRESS_DCA_DAIX_ETHGX: ENV.LOCAL_ADDRESS_DCA_DAIX_ETHGX,
  //   ADDRESS_DCA_DAIX_ETHGX_IDX: ENV.LOCAL_ADDRESS_DCA_DAIX_ETHGX_IDX,

  //   ADDRESS_DAI: ENV.LOCAL_ADRESS_DAI,
  //   ADDRESS_DAIX: ENV.LOCAL_ADRESS_DAIX,
  //   ADDRESS_ETHG: ENV.LOCAL_ADRESS_ETHG,
  //   ADDRESS_ETHGX: ENV.LOCAL_ADRESS_ETHGX,
  // },

  // hardhat chain w/ fork
  31337: {
    ADDRESS_SUPERFLUID_RESOLVER: ENV.LOCAL_ADDRESS_SUPERFLUID_RESOLVER,
    ADDRESS_SUPERFLUID_HOST: ENV.LOCAL_ADDRESS_SUPERFLUID_HOST,
    ADDRESS_SUPERFLUID_CFA: ENV.LOCAL_ADDRESS_SUPERFLUID_CFA,
    ADDRESS_SUPERFLUID_IDA: ENV.LOCAL_ADDRESS_SUPERFLUID_IDA,
    ADDRESS_SUPERFLUID_CFA_V1_FORWARDER: ENV.LOCAL_ADDRESS_SUPERFLUID_CFA_V1_FORWARDER,

    // erc20s
    ADDRESS_USDC: ENV.LOCAL_ADRESS_USDC,
    ADDRESS_WBTC: ENV.LOCAL_ADRESS_WBTC,
    ADDRESS_WETH: ENV.LOCAL_ADRESS_WETH,
    ADDRESS_WMATIC: ENV.LOCAL_ADRESS_WMATIC,
    ADDRESS_LINK: ENV.LOCAL_ADRESS_LINK,
    ADDRESS_AMKT: ENV.LOCAL_ADRESS_AMKT,
    ADDRESS_GNS: ENV.LOCAL_ADRESS_GNS,
    ADDRESS_CRV: ENV.LOCAL_ADRESS_CRV,

    // supertokens
    ADDRESS_USDCX: ENV.LOCAL_ADRESS_USDCX,
    ADDRESS_WBTCX: ENV.LOCAL_ADRESS_WBTCX,
    ADDRESS_WETHX: ENV.LOCAL_ADRESS_WETHX,
    ADDRESS_WMATICX: ENV.LOCAL_ADRESS_WMATICX,
    ADDRESS_LINKX: ENV.LOCAL_ADRESS_LINKX,
    ADDRESS_AMKTX: ENV.LOCAL_ADRESS_AMKTX,
    ADDRESS_GNSX: ENV.LOCAL_ADRESS_GNSX,
    ADDRESS_CRVX: ENV.LOCAL_ADRESS_CRVX,

    // pools
    ADDRESS_DCA_USDCX_WBTCX: ENV.LOCAL_ADDRESS_DCA_USDCX_WBTCX,
    ADDRESS_DCA_USDCX_WETHX: ENV.LOCAL_ADDRESS_DCA_USDCX_WETHX,
    ADDRESS_DCA_USDCX_WMATICX: ENV.LOCAL_ADDRESS_DCA_USDCX_WMATICX,
    ADDRESS_DCA_USDCX_LINKX: ENV.LOCAL_ADDRESS_DCA_USDCX_LINKX,
    ADDRESS_DCA_USDCX_AMKTX: ENV.LOCAL_ADDRESS_DCA_USDCX_AMKTX,
    ADDRESS_DCA_WMATICX_GNSX: ENV.LOCAL_ADDRESS_DCA_WMATICX_GNSX,
    ADDRESS_DCA_WMATICX_CRVX: ENV.LOCAL_ADDRESS_DCA_WMATICX_CRVX,

    ADDRESS_DCA_USDCX_WBTCX_IDX: ENV.LOCAL_ADDRESS_DCA_USDCX_WBTCX_IDX,
    ADDRESS_DCA_USDCX_WETHX_IDX: ENV.LOCAL_ADDRESS_DCA_USDCX_WETHX_IDX,
    ADDRESS_DCA_USDCX_WMATICX_IDX: ENV.LOCAL_ADDRESS_DCA_USDCX_WMATICX_IDX,
    ADDRESS_DCA_USDCX_LINKX_IDX: ENV.LOCAL_ADDRESS_DCA_USDCX_LINKX_IDX,
    ADDRESS_DCA_USDCX_AMKTX_IDX: ENV.LOCAL_ADDRESS_DCA_USDCX_AMKTX_IDX,
    ADDRESS_DCA_WMATICX_GNSX_IDX: ENV.LOCAL_ADDRESS_DCA_WMATICX_GNSX_IDX,
    ADDRESS_DCA_WMATICX_CRVX_IDX: ENV.LOCAL_ADDRESS_DCA_WMATICX_CRVX_IDX,
  },

  // polygon mumbai
  80001: {
    ADDRESS_SUPERFLUID_RESOLVER: ENV.MUMBAI_ADDRESS_SUPERFLUID_RESOLVER,
    ADDRESS_SUPERFLUID_HOST: ENV.MUMBAI_ADDRESS_SUPERFLUID_HOST,
    ADDRESS_SUPERFLUID_CFA: ENV.MUMBAI_ADDRESS_SUPERFLUID_CFA,
    ADDRESS_SUPERFLUID_IDA: ENV.MUMBAI_ADDRESS_SUPERFLUID_IDA,
    ADDRESS_SUPERFLUID_CFA_V1_FORWARDER: ENV.MUMBAI_ADDRESS_SUPERFLUID_CFA_V1_FORWARDER,

    ADDRESS_DCA_STABLEX_ENCX: ENV.MUMBAI_ADDRESS_DCA_STABLEX_ENCX,
    ADDRESS_DCA_STABLEX_BTFDCAX: ENV.MUMBAI_ADDRESS_DCA_STABLEX_BTFDCAX,
    ADDRESS_DCA_STABLEX_ENCX_IDX: ENV.MUMBAI_ADDRESS_DCA_STABLEX_ENCX_IDX,
    ADDRESS_DCA_STABLEX_BTFDCAX_IDX: ENV.MUMBAI_ADDRESS_DCA_STABLEX_BTFDCAX_IDX,

    ADDRESS_STABLE: ENV.MUMBAI_ADDRESS_STABLE,
    ADDRESS_STABLEX: ENV.MUMBAI_ADDRESS_STABLEX,
    ADDRESS_ENC: ENV.MUMBAI_ADDRESS_ENC,
    ADDRESS_ENCX: ENV.MUMBAI_ADDRESS_ENCX,
    ADDRESS_BTFDCA: ENV.MUMBAI_ADDRESS_BTFDCA,
    ADDRESS_BTFDCAX: ENV.MUMBAI_ADDRESS_BTFDCAX,
  },

  // polygon mainnet
  137: {
    ADDRESS_SUPERFLUID_RESOLVER: ENV.POLYGON_MAINNET_ADDRESS_SUPERFLUID_RESOLVER,
    ADDRESS_SUPERFLUID_HOST: ENV.POLYGON_MAINNET_ADDRESS_SUPERFLUID_HOST,
    ADDRESS_SUPERFLUID_CFA: ENV.POLYGON_MAINNET_ADDRESS_SUPERFLUID_CFA,
    ADDRESS_SUPERFLUID_IDA: ENV.POLYGON_MAINNET_ADDRESS_SUPERFLUID_IDA,
    ADDRESS_SUPERFLUID_CFA_V1_FORWARDER: ENV.POLYGON_MAINNET_ADDRESS_SUPERFLUID_CFA_V1_FORWARDER,

    // erc20s
    ADDRESS_USDC: ENV.POLYGON_MAINNET_ADRESS_USDC,
    ADDRESS_WBTC: ENV.POLYGON_MAINNET_ADRESS_WBTC,
    ADDRESS_WETH: ENV.POLYGON_MAINNET_ADRESS_WETH,
    ADDRESS_WMATIC: ENV.POLYGON_MAINNET_ADRESS_WMATIC,
    ADDRESS_LINK: ENV.POLYGON_MAINNET_ADRESS_LINK,
    ADDRESS_AMKT: ENV.POLYGON_MAINNET_ADRESS_AMKT,
    ADDRESS_GNS: ENV.POLYGON_MAINNET_ADRESS_GNS,
    ADDRESS_CRV: ENV.POLYGON_MAINNET_ADRESS_CRV,
    ADDRESS_MVX: ENV.POLYGON_MAINNET_ADRESS_MVX,

    // supertokens
    ADDRESS_USDCX: ENV.POLYGON_MAINNET_ADRESS_USDCX,
    ADDRESS_WBTCX: ENV.POLYGON_MAINNET_ADRESS_WBTCX,
    ADDRESS_WETHX: ENV.POLYGON_MAINNET_ADRESS_WETHX,
    ADDRESS_WMATICX: ENV.POLYGON_MAINNET_ADRESS_WMATICX,
    ADDRESS_LINKX: ENV.POLYGON_MAINNET_ADRESS_LINKX,
    ADDRESS_AMKTX: ENV.POLYGON_MAINNET_ADRESS_AMKTX,
    ADDRESS_GNSX: ENV.POLYGON_MAINNET_ADRESS_GNSX,
    ADDRESS_CRVX: ENV.POLYGON_MAINNET_ADRESS_CRVX,
    ADDRESS_MVXX: ENV.POLYGON_MAINNET_ADRESS_MVXX,

    // pools
    ADDRESS_DCA_USDCX_WBTCX: ENV.POLYGON_MAINNET_ADDRESS_DCA_USDCX_WBTCX,
    ADDRESS_DCA_USDCX_WETHX: ENV.POLYGON_MAINNET_ADDRESS_DCA_USDCX_WETHX,
    ADDRESS_DCA_USDCX_WMATICX: ENV.POLYGON_MAINNET_ADDRESS_DCA_USDCX_WMATICX,
    ADDRESS_DCA_USDCX_LINKX: ENV.POLYGON_MAINNET_ADDRESS_DCA_USDCX_LINKX,
    ADDRESS_DCA_USDCX_AMKTX: ENV.POLYGON_MAINNET_ADDRESS_DCA_USDCX_AMKTX,
    ADDRESS_DCA_WMATICX_GNSX: ENV.POLYGON_MAINNET_ADDRESS_DCA_WMATICX_GNSX,
    ADDRESS_DCA_WMATICX_CRVX: ENV.POLYGON_MAINNET_ADDRESS_DCA_WMATICX_CRVX,
    ADDRESS_DCA_USDCX_MVXX: ENV.POLYGON_MAINNET_ADDRESS_DCA_USDCX_MVXX,

    ADDRESS_DCA_USDCX_WBTCX_IDX: ENV.POLYGON_MAINNET_ADDRESS_DCA_USDCX_WBTCX_IDX,
    ADDRESS_DCA_USDCX_WETHX_IDX: ENV.POLYGON_MAINNET_ADDRESS_DCA_USDCX_WETHX_IDX,
    ADDRESS_DCA_USDCX_WMATICX_IDX: ENV.POLYGON_MAINNET_ADDRESS_DCA_USDCX_WMATICX_IDX,
    ADDRESS_DCA_USDCX_LINKX_IDX: ENV.POLYGON_MAINNET_ADDRESS_DCA_USDCX_LINKX_IDX,
    ADDRESS_DCA_USDCX_AMKTX_IDX: ENV.POLYGON_MAINNET_ADDRESS_DCA_USDCX_AMKTX_IDX,
    ADDRESS_DCA_WMATICX_GNSX_IDX: ENV.POLYGON_MAINNET_ADDRESS_DCA_WMATICX_GNSX_IDX,
    ADDRESS_DCA_WMATICX_CRVX_IDX: ENV.POLYGON_MAINNET_ADDRESS_DCA_WMATICX_CRVX_IDX,
    ADDRESS_DCA_USDCX_MVXX_IDX: ENV.POLYGON_MAINNET_ADDRESS_DCA_USDCX_MVXX_IDX,
  },
};

const SUPPORTED_TOKENS = {
  // 31337: {
  //   DAIx: {
  //     chainId: 31337,
  //     description: "something about DAI",
  //     erc20Symbol: "DAI",
  //     erc20Address: ADDRESSES[31337].ADDRESS_DAI,
  //     erc20Decimals: 18,
  //     tokenxSymbol: "DAIx",
  //     tokenxAddress: ADDRESSES[31337].ADDRESS_DAIX,
  //     fixedLength: {
  //       minAmount: parseEther("100"),
  //       maxAmount: parseEther("1000000000000000000000000000"),
  //       step: 10,
  //     },
  //     foreverLength: {
  //       minAmount: parseEther("0.5"),
  //       maxAmount: parseEther("1000000"),
  //       step: 0.1,
  //     },
  //   },
  //   ETHGx: {
  //     chainId: 31337,
  //     description: "ETH Global!",
  //     erc20Symbol: "ETHG",
  //     erc20Address: ADDRESSES[31337].ADDRESS_ETHG,
  //     erc20Decimals: 18,
  //     tokenxSymbol: "ETHGx",
  //     tokenxAddress: ADDRESSES[31337].ADDRESS_ETHGX,
  //   },
  // },
  31337: {
    USDCx: {
      chainId: 31337,
      description: "",
      erc20Symbol: "USDC",
      erc20Address: ADDRESSES[31337].ADDRESS_USDC,
      erc20Decimals: 6,
      tokenxSymbol: "USDCx",
      tokenxAddress: ADDRESSES[31337].ADDRESS_USDCX,
      fixedLength: {
        minAmount: parseEther("100"),
        maxAmount: parseEther("1000000000"),
        step: 10,
      },
      foreverLength: {
        minAmount: parseEther("0.5"),
        maxAmount: parseEther("1000000"),
        step: 0.1,
      },
    },
    WBTCx: {
      chainId: 31337,
      description:
        'Bitcoin is often referred to as the "gold of crypto" because it was the first decentralized digital currency, and has maintained the position of the most valuable cryptoasset since its creation. It has a limited supply, and is seen as a store of value and potential investment.',
      erc20Symbol: "WBTC",
      erc20Address: ADDRESSES[31337].ADDRESS_WBTC,
      erc20Decimals: 8,
      tokenxSymbol: "WBTCx",
      tokenxAddress: ADDRESSES[31337].ADDRESS_WBTCX,
    },
    WETHx: {
      chainId: 31337,
      description:
        "Ethereum is the main smart contract blockchain, and the backbone of decentralized applications (dApps) as well as numerous layer 2 solutions. The native token is ether, and is used for securing the network, and to pay for transactions. Since the transition to Proof-of-Stake in September 2022, Ethereum is sometimes deflationary through fee burns.",
      erc20Symbol: "WETH",
      erc20Address: ADDRESSES[31337].ADDRESS_WETH,
      erc20Decimals: 18,
      tokenxSymbol: "WETHx",
      tokenxAddress: ADDRESSES[31337].ADDRESS_WETHX,
    },
    WMATICx: {
      chainId: 31337,
      description:
        "Polygon is one of the most popular decentralised Ethereum scaling platforms, and home to many DeFi applications. MATIC is its native token, and is used to pay for transactions, securing the network, and governance.",
      erc20Symbol: "WMATIC",
      erc20Address: ADDRESSES[31337].ADDRESS_WMATIC,
      erc20Decimals: 18,
      tokenxSymbol: "WMATICx",
      tokenxAddress: ADDRESSES[31337].ADDRESS_WMATICX,
      fixedLength: {
        minAmount: parseEther("100"),
        maxAmount: parseEther("1000000000"),
        step: 10,
      },
      foreverLength: {
        minAmount: parseEther("1"),
        maxAmount: parseEther("1000000"),
        step: 0.1,
      },
    },
    LINKx: {
      chainId: 31337,
      description:
        "Chainlink is a decentralized oracle networks (DONs) that provides tamper-proof inputs, outputs, and computations to support advanced smart contracts on any blockchain. LINK is the token that is used to incentivize the proper operation of Chainlink DONs.",
      erc20Symbol: "LINK",
      erc20Address: ADDRESSES[31337].ADDRESS_LINK,
      erc20Decimals: 18,
      tokenxSymbol: "LINKx",
      tokenxAddress: ADDRESSES[31337].ADDRESS_LINKX,
    },
    AMKTx: {
      chainId: 31337,
      description:
        "Alongside Crypto Market Index represents a basket of digital assets designed to track the market capitalization of the cryptoasset market. This index tracks the performance of the top 25 crypto assets, rebalancing monthly, and reconstituting quarterly. AMKT charges a 0.95% yearly fee. Note: this is a new token, and as such it has low liquidity.",
      erc20Symbol: "AMKT",
      erc20Address: ADDRESSES[31337].ADDRESS_AMKT,
      erc20Decimals: 18,
      tokenxSymbol: "AMKTx",
      tokenxAddress: ADDRESSES[31337].ADDRESS_AMKTX,
    },
    GNSx: {
      chainId: 31337,
      description:
        "Gains Network aims to be a DeFi ecosystem of products, and currently develops and operates gTrade, a decentralized leveraged trading platform. GNS is the utility token for the network, acting as a mechanism of liquidity efficiency, and provides returns for those participating in the ecosystem.",
      erc20Symbol: "GNS",
      erc20Address: ADDRESSES[31337].ADDRESS_GNS,
      erc20Decimals: 18,
      tokenxSymbol: "GNSx",
      tokenxAddress: ADDRESSES[31337].ADDRESS_GNSX,
    },
    CRVx: {
      chainId: 31337,
      description:
        "Curve is an exchange liquidity pool (similar to Uniswap), designed for extremely efficient stablecoin trading and low risk, supplemental fee income for liquidity providers, without an opportunity cost. CRV is the token for the Curve DAO, which is used for both governance and value accrual.",
      erc20Symbol: "CRV",
      erc20Address: ADDRESSES[31337].ADDRESS_CRV,
      erc20Decimals: 18,
      tokenxSymbol: "CRVx",
      tokenxAddress: ADDRESSES[31337].ADDRESS_CRVX,
    },
  },
  80001: {
    STABLEx: {
      chainId: 80001,
      description: "something about stables",
      erc20Symbol: "STABLE",
      erc20Address: ADDRESSES[80001].ADDRESS_STABLE,
      erc20Decimals: 18,
      tokenxSymbol: "STABLEx",
      tokenxAddress: ADDRESSES[80001].ADDRESS_STABLEX,
      fixedLength: {
        minAmount: parseEther("100"),
        maxAmount: parseEther("1000000000"), // you probably don't want to DCA more than a billy?
        step: 10,
      },
      foreverLength: {
        minAmount: parseEther("0.5"),
        maxAmount: parseEther("1000000"), // you sure you wanna DCA a milly a day?
        step: 0.1,
      },
    },
    ENCx: {
      chainId: 80001,
      description: "something about encx",
      erc20Symbol: "ENC",
      erc20Address: ADDRESSES[80001].ADDRESS_ENC,
      erc20Decimals: 18,
      tokenxSymbol: "ENCx",
      tokenxAddress: ADDRESSES[80001].ADDRESS_ENCX,
    },
    BTFDCAx: {
      chainId: 80001,
      description:
        "something about btfdca, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.",
      erc20Symbol: "BTFDCA",
      erc20Address: ADDRESSES[80001].ADDRESS_BTFDCA,
      erc20Decimals: 18,
      tokenxSymbol: "BTFDCAx",
      tokenxAddress: ADDRESSES[80001].ADDRESS_BTFDCAX,
    },
  },
  137: {
    USDCx: {
      chainId: 137,
      description: "",
      erc20Symbol: "USDC",
      erc20Address: ADDRESSES[137].ADDRESS_USDC,
      erc20Decimals: 6,
      tokenxSymbol: "USDCx",
      tokenxAddress: ADDRESSES[137].ADDRESS_USDCX,
      fixedLength: {
        minAmount: parseEther("100"),
        maxAmount: parseEther("1000000000"),
        step: 10,
      },
      foreverLength: {
        minAmount: parseEther("0.5"),
        maxAmount: parseEther("1000000"),
        step: 0.1,
      },
    },
    WBTCx: {
      chainId: 137,
      description:
        'Bitcoin is often referred to as the "gold of crypto" because it was the first decentralized digital currency, and has maintained the position of the most valuable cryptoasset since its creation. It has a limited supply, and is seen as a store of value and potential investment.',
      erc20Symbol: "WBTC",
      erc20Address: ADDRESSES[137].ADDRESS_WBTC,
      erc20Decimals: 8,
      tokenxSymbol: "WBTCx",
      tokenxAddress: ADDRESSES[137].ADDRESS_WBTCX,
    },
    WETHx: {
      chainId: 137,
      description:
        "Ethereum is the main smart contract blockchain, and the backbone of decentralized applications (dApps) as well as numerous layer 2 solutions. The native token is ether, and is used for securing the network, and to pay for transactions. Since the transition to Proof-of-Stake in September 2022, Ethereum is sometimes deflationary through fee burns.",
      erc20Symbol: "WETH",
      erc20Address: ADDRESSES[137].ADDRESS_WETH,
      erc20Decimals: 18,
      tokenxSymbol: "WETHx",
      tokenxAddress: ADDRESSES[137].ADDRESS_WETHX,
    },
    WMATICx: {
      chainId: 137,
      description:
        "Polygon is one of the most popular decentralised Ethereum scaling platforms, and home to many DeFi applications. MATIC is its native token, and is used to pay for transactions, securing the network, and governance.",
      erc20Symbol: "WMATIC",
      erc20Address: ADDRESSES[137].ADDRESS_WMATIC,
      erc20Decimals: 18,
      tokenxSymbol: "WMATICx",
      tokenxAddress: ADDRESSES[137].ADDRESS_WMATICX,
      fixedLength: {
        minAmount: parseEther("100"),
        maxAmount: parseEther("1000000000"),
        step: 10,
      },
      foreverLength: {
        minAmount: parseEther("1"),
        maxAmount: parseEther("1000000"),
        step: 0.1,
      },
    },
    LINKx: {
      chainId: 137,
      description:
        "Chainlink is a decentralized oracle networks (DONs) that provides tamper-proof inputs, outputs, and computations to support advanced smart contracts on any blockchain. LINK is the token that is used to incentivize the proper operation of Chainlink DONs.",
      erc20Symbol: "LINK",
      erc20Address: ADDRESSES[137].ADDRESS_LINK,
      erc20Decimals: 18,
      tokenxSymbol: "LINKx",
      tokenxAddress: ADDRESSES[137].ADDRESS_LINKX,
    },
    AMKTx: {
      chainId: 137,
      description:
        "Alongside Crypto Market Index represents a basket of digital assets designed to track the market capitalization of the cryptoasset market. This index tracks the performance of the top 25 crypto assets, rebalancing monthly, and reconstituting quarterly. AMKT charges a 0.95% yearly fee. Note: this is a new token, and as such it has low liquidity.",
      erc20Symbol: "AMKT",
      erc20Address: ADDRESSES[137].ADDRESS_AMKT,
      erc20Decimals: 18,
      tokenxSymbol: "AMKTx",
      tokenxAddress: ADDRESSES[137].ADDRESS_AMKTX,
    },
    GNSx: {
      chainId: 137,
      description:
        "Gains Network aims to be a DeFi ecosystem of products, and currently develops and operates gTrade, a decentralized leveraged trading platform. GNS is the utility token for the network, acting as a mechanism of liquidity efficiency, and provides returns for those participating in the ecosystem.",
      erc20Symbol: "GNS",
      erc20Address: ADDRESSES[137].ADDRESS_GNS,
      erc20Decimals: 18,
      tokenxSymbol: "GNSx",
      tokenxAddress: ADDRESSES[137].ADDRESS_GNSX,
    },
    CRVx: {
      chainId: 137,
      description:
        "Curve is an exchange liquidity pool (similar to Uniswap), designed for extremely efficient stablecoin trading and low risk, supplemental fee income for liquidity providers, without an opportunity cost. CRV is the token for the Curve DAO, which is used for both governance and value accrual.",
      erc20Symbol: "CRV",
      erc20Address: ADDRESSES[137].ADDRESS_CRV,
      erc20Decimals: 18,
      tokenxSymbol: "CRVx",
      tokenxAddress: ADDRESSES[137].ADDRESS_CRVX,
    },
    MVXx: {
      chainId: 137,
      description:
        "Metavault.Trade is one of the top perpetuals exchanges on Polygon. Originally a GMX fork, it follows similar mechanics and tokenomics. MVX is the governance and utility token - it can be staked for rewards. Try it on https://metavault.trade/",
      erc20Symbol: "MVX",
      erc20Address: ADDRESSES[137].ADDRESS_MVX,
      erc20Decimals: 18,
      tokenxSymbol: "MVXx",
      tokenxAddress: ADDRESSES[137].ADDRESS_MVXX,
    },
  },
};

const ASSET_TOKENS_PAIRS = {
  // format: chain -> target asset -> source tokens
  // 31337: {
  //   ETHGx: {
  //     DAIx: {
  //       contractAddress: ADDRESSES[31337].ADDRESS_DCA_DAIX_ETHGX,
  //       index: ADDRESSES[31337].ADDRESS_DCA_DAIX_ETHGX_IDX,
  //     },
  //   },
  // },
  31337: {
    WBTCx: {
      USDCx: {
        contractAddress: ADDRESSES[31337].ADDRESS_DCA_USDCX_WBTCX,
        index: ADDRESSES[31337].ADDRESS_DCA_USDCX_WBTCX_IDX,
      },
    },
    WETHx: {
      USDCx: {
        contractAddress: ADDRESSES[31337].ADDRESS_DCA_USDCX_WETHX,
        index: ADDRESSES[31337].ADDRESS_DCA_USDCX_WETHX_IDX,
      },
    },
    WMATICx: {
      USDCx: {
        contractAddress: ADDRESSES[31337].ADDRESS_DCA_USDCX_WMATICX,
        index: ADDRESSES[31337].ADDRESS_DCA_USDCX_WMATICX_IDX,
      },
    },
    LINKx: {
      USDCx: {
        contractAddress: ADDRESSES[31337].ADDRESS_DCA_USDCX_LINKX,
        index: ADDRESSES[31337].ADDRESS_DCA_USDCX_LINKX_IDX,
      },
    },
    AMKTx: {
      USDCx: {
        contractAddress: ADDRESSES[31337].ADDRESS_DCA_USDCX_AMKTX,
        index: ADDRESSES[31337].ADDRESS_DCA_USDCX_AMKTX_IDX,
      },
    },
    GNSx: {
      WMATICx: {
        contractAddress: ADDRESSES[31337].ADDRESS_DCA_WMATICX_GNSX,
        index: ADDRESSES[31337].ADDRESS_DCA_WMATICX_GNSX_IDX,
      },
    },
    CRVx: {
      WMATICx: {
        contractAddress: ADDRESSES[31337].ADDRESS_DCA_WMATICX_CRVX,
        index: ADDRESSES[31337].ADDRESS_DCA_WMATICX_CRVX_IDX,
      },
    },
  },
  80001: {
    ENCx: {
      STABLEx: {
        contractAddress: ADDRESSES[80001].ADDRESS_DCA_STABLEX_ENCX,
        index: ADDRESSES[80001].ADDRESS_DCA_STABLEX_ENCX_IDX,
      },
    },
    BTFDCAx: {
      STABLEx: {
        contractAddress: ADDRESSES[80001].ADDRESS_DCA_STABLEX_BTFDCAX,
        index: ADDRESSES[80001].ADDRESS_DCA_STABLEX_BTFDCAX_IDX,
      },
    },
  },
  137: {
    AMKTx: {
      USDCx: {
        contractAddress: ADDRESSES[137].ADDRESS_DCA_USDCX_AMKTX,
        index: ADDRESSES[137].ADDRESS_DCA_USDCX_AMKTX_IDX,
      },
    },
    CRVx: {
      WMATICx: {
        contractAddress: ADDRESSES[137].ADDRESS_DCA_WMATICX_CRVX,
        index: ADDRESSES[137].ADDRESS_DCA_WMATICX_CRVX_IDX,
      },
    },
    GNSx: {
      WMATICx: {
        contractAddress: ADDRESSES[137].ADDRESS_DCA_WMATICX_GNSX,
        index: ADDRESSES[137].ADDRESS_DCA_WMATICX_GNSX_IDX,
      },
    },
    LINKx: {
      USDCx: {
        contractAddress: ADDRESSES[137].ADDRESS_DCA_USDCX_LINKX,
        index: ADDRESSES[137].ADDRESS_DCA_USDCX_LINKX_IDX,
      },
    },
    MVXx: {
      USDCx: {
        contractAddress: ADDRESSES[137].ADDRESS_DCA_USDCX_MVXX,
        index: ADDRESSES[137].ADDRESS_DCA_USDCX_MVXX_IDX,
      },
    },
    WBTCx: {
      USDCx: {
        contractAddress: ADDRESSES[137].ADDRESS_DCA_USDCX_WBTCX,
        index: ADDRESSES[137].ADDRESS_DCA_USDCX_WBTCX_IDX,
      },
    },
    WETHx: {
      USDCx: {
        contractAddress: ADDRESSES[137].ADDRESS_DCA_USDCX_WETHX,
        index: ADDRESSES[137].ADDRESS_DCA_USDCX_WETHX_IDX,
      },
    },
    WMATICx: {
      USDCx: {
        contractAddress: ADDRESSES[137].ADDRESS_DCA_USDCX_WMATICX,
        index: ADDRESSES[137].ADDRESS_DCA_USDCX_WMATICX_IDX,
      },
    },
  },
};

const SF_CHAIN_NAMES = {
  // matches names in https://console.superfluid.finance/ links
  137: "matic",
  10: "optimism-mainnet",
  42161: "arbitrum-one",
  56: "bnb-smart-chain",
  80001: "mumbai",
  5: "goerli",
};

export { NUM_CONFIRMATIONS, ADDRESSES, SUPPORTED_TOKENS, ASSET_TOKENS_PAIRS, SF_CHAIN_NAMES };
